
export function uiToApiReportOptions(uiReportOptions) {
  return uiReportOptions.join(',');
}

export function apiToUiReportOptions(apiReportOptions) {
  return apiReportOptions ?
    apiReportOptions.split(',').map(option => option.trim()) :
    [];
}
